

































































import { Vue, Component } from 'vue-property-decorator'
import { exists, emailRules, passwordRules, passwordMatches } from '@/util/inputValidation'
import Arrows from '@/components/Arrows.vue'
import { sendResetPasswordEmail, resetPassword } from '@/services/auth'
import { showToast } from '@/services/app'

@Component({
  metaInfo: {
    title: 'Reset password'
  },
  components: {
    Arrows,
  },
})
export default class ResetPassword extends Vue {

  form = {
    email: '',
    password: '',
    confirmPassword: '',
  }
  isValid = false
  loading = false
  emailRules = emailRules
  showPassword = false
  hasToken = false
  rules = {
    password: passwordRules,
    confirmPassword: [exists('Password confirmation required')],
    passwordMatches,
  }

  mounted() {
    if (this.$route.query.token) {
      this.hasToken = true
    }

    if (this.$route.params.email) {
      this.form.email = this.$route.params.email
    }
  }

  get usingSandbox() {
    return this.form.email.includes('+test')
  }

  async submit() {
    this.loading = true
    try {
      if (this.hasToken) {
        await resetPassword(
          this.$store,
          this.$route.query.token as string,
          this.$route.query.email as string,
          this.form.password
        )
      }
      else {
        await sendResetPasswordEmail(this.$store, this.form.email)
        showToast(this.$store, {text: 'Reset link sent'})
      }
    }
    finally {
      this.loading = false
    }
  }
}
